// The backfires: spells that hurt their own caster. None is left. The three
// that were here turned on the enemy on 2026-10-12, when a spell became
// something a caster pays for, and they are in debuffs.ts now. Rob: "those
// should flip to target the enemy". The polarity stays, for a later one.

import type { SpellMechanic } from '../types';

export const BACKFIRES: readonly SpellMechanic[] = [];
